import * as Parse from 'parse';

export const Variable = (t: any, p: string) => {
    Object['defineProperty'](t, p, {
        configurable: true,
        enumerable: true,
        get() {
            return this['get'](p)
        },
        // tslint:disable-next-line:object-literal-shorthand
        set(value: any) {
            this['set'](p, value)
        }
    } as any)
}

export const Relation = (t: any, p: string) => {
    Object['defineProperty'](t, p, {
        configurable: true,
        enumerable: true,
        // tslint:disable-next-line:object-literal-shorthand
        get():Parse.Relation {
            // tslint:disable-next-line:no-string-literal
            return this['relation'](p)
        }
    })
}


// WEBPACK FOOTER //
// ./src/decorators/model.ts